import ValidService from '../../../service/ValidService';
let model = {};

// dữ liệu form
model.dataForm = {
    "name": undefined, // required Tên chi nhánh
    "company_id": undefined, // required Mã công ty
    "value": undefined, // required Giá trị hệ số
    "code": undefined, // required
    "type": undefined, // required, enum(TAKE_BREAK_WORK, GO_LATE, COME_BACK_SOON, WORK_EXPLANATION, GO_OUT, GO_ON_BUSSINESS) Loại lý do xin nghỉ làm, đi muộn, về sớm, giải trình công, ra ngoài, công tác
    "disabled": undefined, // required Đã bị khóa chưa
    "index": undefined, // required - Số thứ tự
    "icon": {
      "image_icon_id": undefined, // requiredoptional, ref: mushroom_file - Icon dạng ảnh
      "font_icon": undefined, // optional - Icon dạng font
    }, // optional - Icon
    "url": undefined, // optional - Url
    "description": undefined, // optional - Description
    "identity": undefined, // required
    "is_broken": undefined, // required
    "status": undefined, // required
};

// validation form
model.validForm = {
    "name": [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkVietNameseHaveNumber,
            ValidService.checkMaxLength(30),
        ], // required Tên chi nhánh
    "company_id": [ValidService.requiredChange], // required Mã công ty
    "value": [ValidService.required], // required Giá trị hệ số
    "code": [
                ValidService.required,
                ValidService.checkSpaceString,
                ValidService.checkVietNameseHaveNumber,
                ValidService.checkSpaceStringCenter
            ], // required
    "type": [ValidService.required,ValidService.checkSpaceString,ValidService.requiredChange],
    "disabled": [], // required Đã bị khóa chưa
    "index": [ValidService.required],
    "identity": [ValidService.required, ValidService.checkSpaceString, ValidService.checkSpaceStringCenter], // required
    "is_broken": [ValidService.requiredChange], // required
    "status": [ValidService.requiredChange], // required
};

// dữ liệu mẫu các form khác
model.dataFormOther = {

};

// validation các form khác
model.validFormOther = {};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "name": "",
            "company_id": "",
            "value": undefined,
            "code": "",
            "type": "",
            "disabled": "",
            "identity": "",
            "status": "",
            "is_broken": "",
        },
        valid: {
            "name": [],
            "company_id": [],
            "value": [],
            "code": [],
            "type": [],
            "disabled": [],
            "identity": [ValidService.checkSpaceString, ValidService.checkSpaceStringCenter],
            "status": [],
            "is_broken": [],
        },
        operator: {
            "name": "$vn_text=",
            "company_id": "",
            "value": "",
            "code": ":regex_i:",
            "type": "",
            "disabled": "",
            "identity": ":regex_i:",
            "status": "",
            "is_broken": "",
        }
    }
};

export default model;
